import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function startCreatorHouseCheckout({ firstName, email }) {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    lookup_key: "creator_house",
    origin_url: window.location.origin,
    first_name: firstName,
    email,
  });
  if (data?.checkout_url) {
    window.location.href = data.checkout_url;
    return true;
  }
  throw new Error("No checkout URL returned");
}

export async function getPaymentStatus(sessionId) {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
}
